<template>
  <BModal
    title="Lançamento de produtos"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
    :hide-header-close="true"
    :centered="true"
    ok-title="Gravar"
    cancel-title="Cancelar"
    v-model="mostrar"
    @ok="gravar"
    @cancel="sair(false)">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true" />
    <BForm
      @submit.prevent="adicionar"
      class="modal__container">
      <InputSugestaoProdutos
        ref="refInputProduto"
        label="Produto*"
        name="inputProduto"
        class="input__produto"
        v-model="form.produto"
        v-validate="'required'"
        :errorsBag="errors" />

      <InputBasico
        ref="refInputQuantidade"
        type="number"
        label="Quantidade*"
        name="inputQuantidade"
        class="input__quantidade"
        v-model="form.quantidade"
        v-validate="'required|min_value:0'"
        :errorsBag="errors" />

      <InputBasico
        v-if="form.produto"
        type="text"
        :disabled="true"
        label="Valor unitário"
        name="inputValorUnitario"
        class="input__valorunitario"
        v-model="form.produto.preco" />

      <div class="input__botaoAdicionar">
        <BButton
          type="submit"
          variant="primary">
          Adicionar
        </BButton>
      </div>

      <BTable
        v-if="produtos.length > 0"
        stacked="sm"
        striped
        :items="produtos"
        :fields="camposTabela"
        class="listaProdutos">

        <template
          slot="produto.preco"
          slot-scope="data">
          {{data.value | currency}}
        </template>

        <template
          slot="deletar"
          slot-scope="data">
          <BButton
            size="sm"
            @click="removerProduto(data.index)"
            variant="danger">
            X
          </BButton>
        </template>
      </BTable>
    </BForm>
  </BModal>
</template>

<script>
import _ from 'lodash'
import {
  BForm,
  BModal,
  BTable,
  BButton,
} from 'bootstrap-vue/es/components'
import InputBasico from '@/components/inputs/InputBasico.vue'
import InputSugestaoProdutos from '@/modules/administrativo/components/inputs/sugestao/InputSugestaoProdutos.vue'

export default {
  name: 'PainelIndicacaoModal',
  components: {
    BForm,
    BModal,
    BTable,
    BButton,
    InputBasico,
    InputSugestaoProdutos,
  },
  data() {
    return {
      resolve: null,
      mostrar: false,
      form: this.valoresIniciaisForm(),
      produtos: [],
      camposTabela: this.retornaCamposMostrarTabela(),
      isLoading: false,
    }
  },
  methods: {
    valoresIniciaisForm() {
      return {
        produto: null,
        quantidade: 0,
      }
    },
    pop(produtoAtendimento) {
      this.limpar()
      this.focarPrimeiroCampo()

      this.produtos = produtoAtendimento || []
      this.mostrar = true

      return new Promise(resolve => {
        this.resolve = resolve
      })
    },
    async gravar(event) {
      event.preventDefault()
      const dadosGravar = this.retornaDadosGravar()
      this.sair(dadosGravar)
    },
    retornaDadosGravar() {
      if (this.produtos.length > 0) {
        const somaTotalBarbeiro = _.sumBy(this.produtos,
          item => item.produto.valorbarbeiro * item.quantidade)

        const somaTotalProdutos = _.sumBy(this.produtos,
          item => item.produto.preco * item.quantidade)

        const retorno = {
          lista: this.produtos,
          totalBarbeiro: somaTotalBarbeiro,
          totalProdutos: somaTotalProdutos,
        }

        return retorno
      }

      return []
    },
    sair(resolve = false) {
      this.mostrar = false
      this.resolve(resolve)
    },
    adicionar() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.produtos.push(this.form)
          this.form = this.valoresIniciaisForm()
          this.$validator.reset()
          this.errors.clear()
          this.focarPrimeiroCampo()
        }
      })
    },
    focarPrimeiroCampo() {
      setTimeout(() => {
        this.$refs.refInputProduto.focar()
      }, 1)
    },
    retornaCamposMostrarTabela() {
      return [
        { key: 'produto.nome', label: 'Produto' },
        { key: 'produto.preco', label: 'Valor Un.' },
        { key: 'quantidade', label: 'Quantidade' },
        { key: 'deletar', label: '' },
      ]
    },
    removerProduto(indice) {
      this.produtos.splice(indice, 1)
      this.focarPrimeiroCampo()
    },
    mostrarLoading(mostrar = true) {
      this.isLoading = mostrar
    },
    limpar() {
      this.form = this.valoresIniciaisForm()
      this.produtos = []
      this.isLoading = false
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

.modal__container {
  @media (min-width: $medium-size) {
    display: grid;
    grid-column-gap: 0.8em;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: auto;
  }
}

.input {
  &__produto {
    @media (min-width: $medium-size) {
      grid-column: 1 / -1;
    }
  }

  &__quantidade {
    @media (min-width: $medium-size) {
      grid-column: 1 / 3;
    }
  }

  &__valorunitario {
    @media (min-width: $medium-size) {
      grid-column: 3 / -2;
    }
  }

  &__botaoAdicionar {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    @media (min-width: $medium-size) {
      grid-column: 1 / -1;
    }
  }
}

.listaProdutos {
  @media (min-width: $medium-size) {
    grid-column: 1 / -1;
  }
}

</style>
